export default __webpack_public_path__ + "static/media/org-logo.c2d6048c.svg";